import React from 'react'

import { OAuthCallback } from './components'
import { LoginPage, LogoutPage } from './pages'

export const routes = {
  root: [
    {
      path: 'login',
      label: 'Entrar',
      element: <LoginPage />
    },
    {
      path: 'logout',
      element: <LogoutPage />
    },
    {
      path: 'callback',
      element: <OAuthCallback />
    }
  ]
}

export default routes
